import React from 'react';
import {Select, Switch} from "antd";

const Rtmp = () => {
    const onChange = () => {

    }
    return (
        <div className="ip-settings main-padding">
            <div className="camera-config-header">
                <span>Home</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>System Management</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>IP Settings</span>
            </div>

            <div className="camera-config-content">
                <h6 className="alert-title-cmcf">
                    If you modify an IP address, subnet mask, gateway, or Web port, the software will restart!
                </h6>

                <div className="my-avform mt-4">

                    <div className="row">
                        <div className="col-md-2 text-end text-white">Automatically Get The DNS </div>
                        <div className="col-md-4"><div className="status-rtmp">
                            <span className="status-rtmp-active">
                                Registed
                            </span>
                        </div></div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-2 text-end text-white">Enable</div>
                        <div className="col-md-4">   <Switch defaultChecked onChange={onChange} /></div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 text-end">
                            <label  className="text-white">
                                Stream Type
                            </label>
                        </div>
                        <div className="col-md-4">
                            <Select

                                placeholder="Поиск, чтобы выбрать"
                                optionFilterProp="children"
                                className="w-100"

                            >
                                <option value="1">asd</option>
                                <option value="3">asd</option>
                                <option value="2">asd</option>
                            </Select>
                        </div>
                    </div>
                </div>
                <div className="my-avform mt-3">
                    <div className="row mt-2">
                        <div className="col-md-2 text-end">
                            <label  className="text-white">
                                Server Address
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input type="text" className="w-100 p-2"/>
                        </div>
                    </div>
                    <div className="offset-2 col-md-4 mt-3">
                        <button className="btn btn-primary">SET</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Rtmp;